import { ApuResourceApiModel } from '@/core/models/api/apu-resource-api.model';
import { TenderApiModel } from '@/core/models/api/tender-api-model.model';

export interface TenderState {
    // Single slots for objects (Option 1)
    currentTender: TenderApiModel | null;
    execution: TenderApiModel | null;
    
    // UI State
    loading: boolean;
    errorMessage: string | null;
    
    // Contextual selection
    currentExecutionApuId: number | null;
    selectedApuResourceMaterial: ApuResourceApiModel | null;
}

export const initialTenderState: TenderState = {
    currentTender: null,
    execution: null,
    loading: false,
    errorMessage: null,
    currentExecutionApuId: null,
    selectedApuResourceMaterial: null
};